import React, { useContext, useEffect } from "react";
import { ResultContext } from "../ResultContext";

export function BadAfterVestingInput({ questionId }: { questionId: number }) {
  const { result, setResult } = useContext(ResultContext);

  const foundResult = (result[questionId] as boolean) || false;

  useEffect(() => {
    if (!result[questionId]) {
      const copy = { ...result };

      copy[questionId] = false;

      setResult(copy);
    }
    // eslint-disable-next-line
  }, [questionId]);

  return (
    <div className="flex flex-column">
      <label>Bad leaver after vesting? </label>
      <select
        value={foundResult ? "yes" : "no"}
        onChange={(e) => {
          const copy = { ...result };

          if (e.target.value === "yes") {
            copy[questionId] = true;
          } else {
            copy[questionId] = false;
          }

          setResult(copy);
        }}
      >
        <option value="no">No</option>
        <option value="yes">Yes</option>
      </select>
    </div>
  );
}
